<template>
  <page-outline :title="$t('Webheader.account_tb')">
    <template slot="pageContent">
      <b-container fluid>
        <div class="requestsList">
          <div class="mt-0">
            <div>
              <AccountTBList :type="TrackType" :id="id"></AccountTBList>
            </div>
          </div>
        </div>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import AccountTBList from './AccountTBList.vue'


export default {
  name: 'AccountTBPage',
  components: {
    AccountTBList,
    'page-outline': PageOutline,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      fields = [
        { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
        { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
        { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
        { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
        { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
        { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
        { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false }
      ]

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.IBAN ||
          this.BIC ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      idTrackAcc: '',
      statusVerification: '',
      mode: 1,
      tabName: 1,
      identifier: '',
      technicalStatus: '',
      BIC: '',
      IBAN: '',
      dateBegin: '',
      returnUrl: '',
      dateEnd: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      trackActive: '',
      TracksList: [],
      TrackType: ''
    }
  },
  created () {
    this.$bus.$emit('switch-selected-menu', '/tracking/' + this.type + '/' + this.id)
    if (this.type === 'DDV' || this.type === 'DDD' || this.type === 'BULKDETAILS'){
      this.tabName = 1
    }
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().tracking.cleanFilterCondition()
  },
}
</script>
